import SlideUpDown from 'vue-slide-up-down';
import Vue from 'vue';
Vue.component('SlideUpDown', SlideUpDown);
